// extracted by mini-css-extract-plugin
export default {"errorTableContainer":"ErrorTable_errorTableContainer__2wlQl","errorTable":"ErrorTable_errorTable__onM8Q","errorButton":"ErrorTable_errorButton__mP451"};